/*doc
---
title: $.routeParams()
name: routeParams
category: Javascript - Helpers
---

Sets the given URL parameter to the given value using history.replaceState.
If value is undefined or null, then the parameter is removed.

TODO: This needs an example and better documentation.

*/
(function($) {
  'use strict'

  $.extend({
    routeParams: routeParams
  })

  function routeParams(action, param, value) {
    var actions = {
      get: getParam,
      set: setParam
    }

    if (action in actions) {
      return actions[action]()
    } else {
      throw new Error(action + ' is not a valid action for $.routeParams()')
    }


    /**
    * Returns the requested param, if no param present then it returns all params.
    */
    function getParam() {
      var params = $.url().param()
      return param ? params[param] : params
    }

    /**
    * Sets the requested param to the given value, if no value present then the
    * param is removed.
    */
    function setParam() {
      var encParam = encodeURIComponent(param),
      url,
      url_regex = new RegExp('([&;?]|^)' + encParam + '(?:=[^&;=?]*|([&;])|$)', 'g'),
      search = location.search,
      replacement,
      regex_replacement

      // # TODO: FIXME: Logic is convoluted, leaves & on end of URL on unsaleable product

      if (value === undefined || value === null) {
        replacement = ''
        regex_replacement = '$1'
      } else {
        replacement = encParam + '=' + encodeURIComponent(value)
        regex_replacement = '$1' + replacement + '$2'
      }
      if (url_regex.test(location.search)) {
        search = location.search.replace(url_regex, regex_replacement)
      } else if (replacement) {
        if (location.search) {
          search = location.search + '&' + replacement
        } else {
          search = '?' + replacement
        }
      }
      if (search == '?') {
        search = ''
      }

      url = location.protocol + '//' + location.host + location.pathname + search

      try {
        history.replaceState(null, null, url)
      } catch (e) {
        console.error('Error setting history URL for variant: ' + e.toString())
      }
    }
  }

}(jQuery))
